export const calcThreeQuarters = (value: number): number => (value / 4) * 3;
